import * as React from 'react';

export function OfferGeneralInfoLayout(props: React.PropsWithChildren<{}>) {
  return <div>{props.children}</div>;
}
